export default __webpack_public_path__ + "static/media/sports_score_black_24dp.2b462c5b.svg";